import { ContentSection, PropertyGrid, StatusBadge, type Kennwert } from '../../muster';

/**
 * Der KI-Anbieter (Batch 8) — nur Anzeige. Die Auswahl selbst ist
 * Konfiguration (Ki:Anbieter / Ki:Rueckfallanbieter in deploy/.env), nicht
 * etwas, das von hier aus umgestellt wird.
 */
export function KiAnbieter({ ki }: { ki: any }) {
  if (!ki) return null;

  const eintraege: Kennwert[] = [
    {
      beschriftung: 'Standardanbieter',
      wert: `${ki.anbieter}${ki.modell ? ` · ${ki.modell}` : ''}`,
    },
    ...(ki.rueckfallmodell
      ? [{ beschriftung: 'Rückfallmodell', wert: ki.rueckfallmodell }]
      : []),
    { beschriftung: 'Rückfallanbieter', wert: ki.rueckfallanbieter || null },
    {
      beschriftung: 'Eingerichtet',
      wert: ki.eingerichtet
        ? <StatusBadge zustand="gut" text="ja" klein />
        : <StatusBadge zustand="warnung" text="kein Schlüssel hinterlegt" klein />,
    },
  ];

  return (
    <ContentSection titel="KI-Anbieter">
      <PropertyGrid spalten={2} eintraege={eintraege} />
    </ContentSection>
  );
}
